import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class Competition extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "slug", Model.attribute('slug'));
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "nameEs", Model.attribute('nameEs'));
    _defineProperty(this, "nameEu", Model.attribute('nameEu'));
    _defineProperty(this, "nameEn", Model.attribute('nameEn'));
    _defineProperty(this, "shortName", Model.attribute('shortName'));
    _defineProperty(this, "allowsLineup", Model.attribute('allowsLineup'));
    _defineProperty(this, "countsForLineupStanding", Model.attribute('countsForLineupStanding'));
    _defineProperty(this, "allowsBolilla", Model.attribute('allowsBolilla'));
    _defineProperty(this, "countsForBolillaStanding", Model.attribute('countsForBolillaStanding'));
    _defineProperty(this, "allowsRatings", Model.attribute('allowsRatings'));
    _defineProperty(this, "isOfficial", Model.attribute('isOfficial'));
    _defineProperty(this, "format", Model.attribute('format'));
    _defineProperty(this, "color", Model.attribute('color'));
    _defineProperty(this, "icon", Model.attribute('icon'));
    _defineProperty(this, "iconUrl", Model.attribute('iconUrl'));
    _defineProperty(this, "matchesCount", Model.attribute('matchesCount'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
  }
  apiEndpoint() {
    return '/nagusi/match-ratings/competitions' + (this.exists ? '/' + this.data.id : '');
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/Competition', Competition);